import React from "react";
import clsx from "clsx";
import styles from "./error-box.module.scss";
import { useTranslation } from "react-i18next";
import icon from "./icon.svg";

interface Props {
  message: string;
  className?: string;
  docUrl?: string;
}

export function ErrorBox(props: Props) {
  const { message, className } = props;

  const wrapperClassNames = clsx(styles.ErrorBoxWrapper, className);

  const { t } = useTranslation();

  const docUrl = props.docUrl || "https://intercom.help/nexar/en/";
  const contactUrl =
    "https://intercom.help/nexar/en/articles/8601544-contact-us";

  return (
    <div className={wrapperClassNames}>
      <div className={styles.IconArea}>
        <img src={icon} alt={"(i)"} className={styles.Icon} />
      </div>
      <div className={styles.TextArea}>
        <div>
          {message}
          {contactUrl && (
            <>
              {" "}
              {t("ifTheIssuePersists")}{" "}
              <a href={contactUrl} target={"_blank"} className={styles.NavItem}>
                {t("contactSupport")}
              </a>
            </>
          )}
          .
        </div>
        <nav className={styles.Nav}>
          <a href={docUrl} target={"_blank"} className={styles.NavItem}>
            {t("learnMore")}
          </a>
        </nav>
      </div>
    </div>
  );
}

export default ErrorBox;
